module.exports = __webpack_public_path__ + "static/Simple Habit-0fc77c8b2c57f131cc85a63d9bf317fe.jpg";